import { render } from "./dlt-header.vue?vue&type=template&id=13c630d0&scoped=true"
import script from "./dlt-header.vue?vue&type=script&lang=js"
export * from "./dlt-header.vue?vue&type=script&lang=js"

import "./dlt-header.vue?vue&type=style&index=0&id=13c630d0&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13c630d0"]])

export default __exports__